<div fxLayoutAlign="space-between center" style="margin-bottom: 24px">
  <h2 class="nomargin">Installing your Direct Widget</h2>
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</div>

<div fxLayout fxLayoutAlign="start stretch" fxLayoutGap="16px" fxLayout.lt-lg="column">
  <div fxFlex class="booking-widget-box">
    <h3>Embed the booking widget on your website</h3>

    <p>
      Copy the code below, and paste it into your own website to start accepting booking requests for this property.
    </p>

    <textarea
      class="booking-widget-textarea clickable"
      [matTooltip]="'Click to copy to clipboard'"
      ngxClipboard
      cbContent="<iframe id=&quot;booking-iframe&quot; sandbox=&quot;allow-top-navigation allow-scripts allow-same-origin&quot; style=&quot;width: 100%; height: 900px&quot; frameborder=&quot;0&quot; src=&quot;{{
        config.BOOKING_WIDGET_BASE_URL + dialogData.widgetId + '/' + dialogData.propertyId
      }}&quot;></iframe>">
<iframe id="booking-iframe" sandbox="allow-top-navigation allow-scripts allow-same-origin" style="width: 100%; height: 900px" frameborder="0" src="{{
        config.BOOKING_WIDGET_BASE_URL + dialogData.widgetId + '/' + dialogData.propertyId
      }}"></iframe></textarea
    >

    <div class="instructions-links">
      <a
        [href]="'https://help.hospitable.com/en/articles/8167042-adding-the-direct-booking-widget-to-a-wix-velo-site'"
        target="_blank">
        Installing on a Wix site? Read our instructions here
      </a>
    </div>
  </div>

  <div fxFlex class="booking-widget-box">
    <h3>Send a direct link</h3>
    <p>
      Send a direct link to a potential guest to allow them to view availability and submit a request to book this
      property?
    </p>

    <p>Copy the link below, and paste it into an email / social media / etc.</p>

    <h4
      class="raspberry-darker clickable"
      [matTooltip]="'Click to copy to clipboard'"
      ngxClipboard
      [cbContent]="config.BOOKING_WIDGET_BASE_URL + dialogData.widgetId + '/' + dialogData.propertyId">
      {{ config.BOOKING_WIDGET_BASE_URL + dialogData.widgetId + '/' + dialogData.propertyId }}
    </h4>
  </div>
</div>
